import {
    captionClassName,
    labelClassName,
    buttonClassName,
    filterContentLayoutSlotClassNames,
} from '@archipro-design/aria';

import type { StyleRule } from '@archipro-design/aria';

export const VideoSortMobile: StyleRule = ({ theme }) => ({
    '& *': {
        '-webkit-tap-highlight-color': 'transparent',
    },

    [`& .${captionClassName}`]: {
        color: theme.siteVariables.colors.charcoal['250'],
    },

    [`& .${filterContentLayoutSlotClassNames.headerAction}`]: {
        [`& .${buttonClassName}:hover`]: {
            textDecoration: 'none',
        },
    },
});

export const FilterToggleMobile: StyleRule = ({ theme }) => ({
    textTransform: 'uppercase',
    [`& .${labelClassName}`]: {
        ...theme.siteVariables.textStyles.Heading.Roman55,
    },
});

export const FilterContentWrap: StyleRule = ({ theme }) => ({
    [`& .${labelClassName}`]: {
        color: theme.siteVariables.colors.charcoal['250'],
    },
});
